// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lifeLinkPensionPrognosis":"_2R_qFV","markdown":"_1nl2P7"};